import { AbstractTranslation } from './AbstractTranslation';

class BlockTranslation extends AbstractTranslation {
  scene_start = {
    kana: 'シーンスタート',
    en: 'Scene Start',
  };
  space_share = {
    kana: 'くうかんきょうゆう',
    en: 'Space sharing',
  };
  on_with_sound = {
    kana: 'ON（こえつき）',
    en: 'ON(with Sound)',
  };
  controller_ui = {
    kana: 'コントローラーひょうじ',
    en: 'Controller UI',
  };
  any_element = {
    kana: 'はんようエンティティ',
    en: 'Any Entity',
  };
  any_attribute = {
    kana: 'はんようぞくせい',
    en: 'Any Attribute',
  };
  speed = {
    kana: 'スピード',
    en: 'Speed',
  };
  pitch = {
    kana: 'じょうげいどう',
    en: 'Up And Dowm',
  };
  stopattouch_false = {
    en: 'Nothing',
    kana: 'なにもしない',
  };
  stopattouch_true = {
    en: 'Stop',
    kana: 'とまる',
  };
  stopattouch = {
    en: 'On Touch',
    kana: 'タッチしたとき',
  };
  ar = {
    en: 'AR',
    kana: 'AR',
  };
  ar_marker = {
    en: 'AR marker',
    kana: 'ARマーカー',
  };
  hiro_marker = {
    en: 'Hiro maker',
    kana: 'Hiroマーカー',
  };
  image_marker = {
    en: 'Natural Image Marker',
    kana: 'イメージマーカー',
  };
  qr_marker = {
    en: 'QR Code maker',
    kana: 'QRコードマーカー',
  };
  ar_marker_found = {
    en: 'Found AR Marker',
    kana: 'ARマーカーをみつけたとき',
  };
  variant_title = {
    en: 'set marker value to variant',
    kana: 'へんすう ',
  };
  set_at_found_marker = {
    en: ' at marker found',
    kana: 'にマーカーのあたいをセット',
  };
  position = {
    en: 'Position',
    kana: 'いち',
  };
  rotation = {
    en: 'Rotation',
    kana: 'かいてん',
  };
  color = {
    en: 'Color',
    kana: 'いろ',
  };
  focus = {
    en: 'Focus',
    kana: 'ちゅうもくてん',
  };
  mouse_or_tap = {
    en: 'Mouse or Tap',
    kana: 'マウスかタップ',
  };
  focus_mouse_or_tap = {
    en: 'Focus Mouse or Tap',
    kana: 'ちゅうもくしてマウスかタップ',
  };
  click_type = {
    en: 'Click Type',
    kana: 'クリックのほうほう',
  };
  group = {
    en: 'Group',
    kana: 'グループ',
  };
  forest = {
    en: 'Forest',
    kana: 'フォレスト',
  };
  meadow_sun = {
    en: 'Meadow(Sun)',
    kana: 'そうげん（たいよう）',
  };
  meadow_night = {
    en: 'Meadow(Night)',
    kana: 'そうげん（よる）',
  };
  wetlands = {
    en: 'Wetlands',
    kana: 'しっち',
  };
  pastel = {
    en: 'Pastel',
    kana: 'パステル',
  };
  gold = {
    en: 'Gold',
    kana: 'ゴールド',
  };
  env = {
    en: 'Environment',
    kana: 'かんきょう',
  };
  env_default = {
    en: 'Default',
    kana: 'デフォルト',
  };
  contact = {
    en: 'Contact',
    kana: 'コンタクト',
  };
  egypt = {
    en: 'Egypt',
    kana: 'エジプト',
  };
  checkerboard = {
    en: 'Checkerboard',
    kana: 'チェッカーボード',
  };
  goaland = {
    en: 'Goaland',
    kana: 'ゴアランド',
  };
  yavapai = {
    en: 'Yavapai',
    kana: 'ヤヴァパイ',
  };
  goldmine = {
    en: 'Goldmine',
    kana: 'ゴールドマイン',
  };
  threetowers = {
    en: 'Three Towers',
    kana: 'ツリータワー',
  };
  poison = {
    en: 'Poison',
    kana: 'ポイズン',
  };
  arches = {
    en: 'Arches',
    kana: 'アーチ',
  };
  tron = {
    en: 'Tron',
    kana: 'トロン',
  };
  japan = {
    en: 'Japan',
    kana: 'ジャパン',
  };
  dream = {
    en: 'Dream',
    kana: 'ドリーム',
  };
  volcano = {
    en: 'Volcano',
    kana: 'ボルケーノ',
  };
  starry = {
    en: 'Starry',
    kana: 'スターレイ',
  };
  osiris = {
    en: 'Osiris',
    kana: 'オシリス',
  };
  marker_value0_63 = {
    en: 'value (0-63)',
    kana: 'すうち (0-63)',
  };
  simple_password = {
    en: 'Simple Password',
    kana: 'パスワードをかける',
  };
  password = {
    en: 'Password',
    kana: 'パスワード',
  };
  gltf_model = {
    en: '3D Model',
    kana: '3D モデル',
  };
  vrm_model = {
    en: 'VRM Model',
    kana: 'VRM モデル',
  };
  name = {
    en: 'Name',
    kana: 'なまえ',
  };
  image_panel = {
    en: 'Image Block',
    kana: 'がぞうパネルブロック',
  };
  to_image_box = {
    en: 'to Image Box',
    kana: 'がぞうボックス',
  };
  scale = {
    en: 'Scale',
    kana: 'おおきさ',
  };
  japanese_words = {
    en: 'Multibyte words',
    kana: 'にほんごのもじ',
  };
  word_size = {
    en: 'Word Size',
    kana: 'もじサイズ',
  };
  ar_location = {
    en: 'AR Location',
    kana: 'ARばしょしてい',
  };
  latitude = {
    en: 'Latitude',
    kana: 'いど',
  };
  longitude = {
    en: 'longitude',
    kana: 'けいど',
  };
  sound = {
    en: 'Sound',
    kana: 'サウンド',
  };
  text_block = {
    en: 'Text',
    kana: 'はんかくえいすうひらがなカタカナ',
  };
  movie = {
    en: 'Movie',
    kana: 'どうが',
  };
  video_block = {
    en: 'Video Block',
    kana: 'どうがブロック',
  };
  sound_block = {
    en: 'Sound Block',
    kana: 'おんがく ブロック',
  };
  videosphere = {
    en: 'Video Sphere',
    kana: 'どうがのくうかん',
  };
  type = {
    en: 'Type',
    kana: 'しゅるい',
  };
  click = {
    en: 'Click',
    kana: 'クリック',
  };
  auto_play = {
    en: 'Auto Play',
    kana: 'じどうさいせい',
  };
  file = {
    en: 'File',
    kana: 'ファイル',
  };
  play_method = {
    en: 'Play',
    kana: 'さいせいほうほう',
  };
  ambient = {
    en: 'Ambient',
    kana: 'まわり',
  };
  directional = {
    en: 'Directional',
    kana: 'ちょくせん',
  };
  hemisphere = {
    en: 'Hemisphere',
    kana: 'はんきゅう',
  };
  point = {
    en: 'Point',
    kana: 'ポイント',
  };
  spot = {
    en: 'Spot',
    kana: 'スポット',
  };
  light = {
    en: 'Light',
    kana: 'ライト',
  };
  light_type = {
    en: 'Light Type',
    kana: 'ひかりのしゅるい',
  };
  light_intensity = {
    en: 'Light Intensity',
    kana: 'ひかりのつよさ',
  };
  title = {
    en: 'Title',
    kana: 'タイトル',
  };
  link_to = {
    en: 'Link To',
    kana: 'さき',
  };
  link = {
    en: 'Link',
    kana: 'リンク',
  };
  model_viewer = {
    en: 'Model Viewer',
    kana: 'ARモデルビュワーβ',
  };
  plane_detect_ar = {
    en: 'Plane Detection AR',
    kana: 'ゆかをみつけるAR',
  };
  width = {
    en: 'Width',
    kana: 'はば',
  };
  depth = {
    en: 'Depth',
    kana: 'おくゆき',
  };
  height = {
    en: 'Height',
    kana: 'たかさ',
  };
  density = {
    en: 'Density',
    kana: 'みつど',
  };
  comment_out = {
    en: 'Comment Out',
    kana: 'コメントアウト',
  };
  camera = {
    en: 'Camera',
    kana: 'カメラ',
  };
  gps_ar_camera = {
    en: 'GPS AR Camera',
    kana: 'GPS ARカメラ',
  };
  cam_longitude = {
    en: 'Camera longitude',
    kana: 'カメラのいど',
  };
  cam_latitude = {
    en: 'Camera latitude',
    kana: 'カメラのけいど',
  };
  ar_scene = {
    en: 'AR Scene',
    kana: 'AR シーン',
  };
  debug_show = {
    en: 'Debug mode on',
    kana: 'デバッグ',
  };
  debug_hidden = {
    en: 'nomal',
    kana: 'ノーマルモード',
  };
  ar_scene_debug = {
    en: 'mode',
    kana: 'モード',
  };
  check_point = {
    en: 'Check Point',
    kana: 'チェックポイント',
  };
  offset_y = {
    en: 'Sight height',
    kana: 'あたまのいち',
  };
  class_attribute = {
    en: 'Class',
    kana: 'クラス',
  };
  to_class = {
    en: 'classify to',
    kana: 'クラス',
  };
  classify = {
    en: '',
    kana: 'にわける',
  };
  dynamic_body_auto = {
    en: 'Auto',
    kana: 'じどう',
  };
  dynamic_body_box = {
    en: 'Box',
    kana: 'ボックス',
  };
  dynamic_body_sphere = {
    en: 'Sphere',
    kana: 'きゅうたい',
  };
  dynamic_body = {
    en: 'Dynamic weight:',
    kana: 'うごく おもさ:',
  };
  static_body = {
    en: 'Static',
    kana: 'うごかない',
  };
  dynamic_body_shape = {
    en: 'Collision Shape',
    kana: 'かたち',
  };
  dynamic_body_mass = {
    en: 'kg',
    kana: 'キログラム',
  };
  image_path = {
    en: 'Image path',
    kana: 'がぞうのばしょ',
  };
  look_at = {
    en: 'Look at',
    kana: 'みつめる',
  };
  only_first_time = {
    en: 'Only first time',
    kana: 'さいしょだけ',
  };
  always = {
    en: 'Always',
    kana: 'いつまでも',
  };
  look_at_the_id = {
    en: 'See an object with ID ',
    kana: 'ID',
  };
  look_at_after = {
    en: '',
    kana: 'をみつめる',
  };
  noavator = {
    en: 'No avator',
    kana: 'アバターなし',
  };
  on_click = {
    en: 'on click',
    kana: 'クリックしたとき',
  };
  block_name = {
    en: 'Block name',
    kana: 'ブロックめい',
  };
  if_on_click = {
    en: 'Process ',
    kana: 'クリックしたときに',
  };
  handle_this = {
    en: 'when click this',
    kana: 'をじっこうする',
  };
  opacity = {
    en: 'Opacity',
    kana: 'とうめい',
  };
  opacity_label = {
    en: '0.0(Transparent) to 1.0',
    kana: '0.0(とうめい)から1.0',
  };
  physic_system_setting = {
    en: 'Physic system setting',
    kana: 'ぶつりえんざんかんきょうせってい',
  };
  gravity = {
    en: 'Gravity',
    kana: 'じゅうりょく',
  };
  friction = {
    en: 'Friction',
    kana: 'まさつ',
  };
  restitution = {
    en: 'Restitution',
    kana: 'はんぱつ',
  };
  iterations = {
    en: 'Iterations',
    kana: 'シュミレータせいど',
  };
  push = {
    en: 'force when clicked',
    kana: 'のチカラでなぐる',
  };
  yes = {
    en: 'Yes',
    kana: 'はい',
  };
  no = {
    en: 'No',
    kana: 'いいえ',
  };
  loop = {
    en: 'Loop',
    kana: 'くりかえし',
  };
  console_show = {
    en: 'Show to console ',
    kana: 'コンソールにひょうじする',
  };
  distance_to = {
    en: 'Distance to',
    kana: 'きょり',
  };
  between_from = {
    en: 'Between from',
    kana: 'ID',
  };
  between_to = {
    en: 'to ID',
    kana: 'とID',
  };
  set_distance_avlue = {
    en: ', set distance value to',
    kana: 'のきょりをへんすう',
  };
  set_into = {
    en: '',
    kana: 'にセットする',
  };
  set = {
    en: 'Set ',
    kana: 'せってい',
  };
  set_by_id = {
    en: 'Set the ID is ',
    kana: 'IDが',
  };
  set_by_class = {
    en: 'Set the class is',
    kana: 'クラスが',
  };
  of = {
    en: 'of',
    kana: 'の',
  };
  into = {
    en: 'to be',
    kana: 'を',
  };
  be = {
    en: '',
    kana: 'にする',
  };
  collide_title1 = {
    en: 'When',
    kana: '',
  };
  collide_title2 = {
    en: 'ID',
    kana: 'ID',
  };
  collide_title3 = {
    en: ' hits another block. Set victim ID in ',
    kana: 'がぶつかったときに、あいてのIDを',
  };
  collide_title4 = {
    en: '',
    kana: 'にセット',
  };
  follow_rotation = {
    en: 'synchronous rotation',
    kana: 'と むき を おなじにする',
  };
  follow_rotation_target = {
    en: 'Target',
    kana: 'あいて',
  };
  in_front_of = {
    en: 'In front of ',
    kana: 'をリードする',
  };
  offset = {
    en: 'offset',
    kana: 'きょり',
  };
  fix_y = {
    en: 'Fix y',
    kana: 'Yを',
  };
  fix_true = {
    en: 'Yes',
    kana: 'うごかさない',
  };
  fix_false = {
    en: 'No',
    kana: 'うごかす',
  };
  networked = {
    en: 'Networked',
    kana: 'ネットワークきょうゆう',
  };
  box = {
    en: 'Box',
    kana: 'ちょくほうたい',
  };
  sphere = {
    en: 'Sphere',
    kana: 'きゅうたい',
  };
  vrm = {
    en: 'VRM',
    kana: 'VRMモデル',
  };
  vrm_anim = {
    en: 'VRM animation',
    kana: 'VRMアニメーション',
  };
  change_by = {
    en: 'Change by',
    kana: 'ずつかえる',
  };
  by_id = {
    en: 'by ID',
    kana: 'IDが',
  };
  by_class = {
    en: 'by Class',
    kana: 'クラスが',
  };
  to_the = {
    en: 'to',
    kana: 'を',
  };
  sky = {
    en: 'Sky',
    kana: 'ぜんてんきゅう',
  };
  file_path = {
    en: 'File Path',
    kana: 'ファイルパス',
  };

  setting = {
    en: 'Setting',
    kana: 'せってい',
  };
  change = {
    en: 'change by',
    kana: 'ずつ',
  };

  do_the = {
    en: 'Do',
    kana: 'する',
  };
  general_asset = {
    en: 'General asset',
    kana: 'はんようアセット',
  };
  asset_path = {
    en: 'Asset Path',
    kana: 'アセットパス',
  };
  general_lib = {
    en: 'General path',
    kana: 'はんようライブラリ',
  };
  lib_path = {
    en: 'Library path',
    kana: 'ライブラリパス',
  };
  set_fetched_data = {
    en: 'Set Fetched Data to',
    kana: 'とりだしたデータをへんすう',
  };
  repeat_loop = {
    en: 'Repeat',
    kana: 'リピート',
  };
  animation_loop = {
    en: 'Animation loop',
    kana: 'アニメーションようのコマおくりを',
  };
  times = {
    en: 'Times',
    kana: '回繰り返す',
  };
  forever_loop = {
    en: 'Forever',
    kana: 'ずっと',
  };
  until_animation = {
    en: 'Until',
    kana: 'まで、アニメーションようのコマおくりをくりかえす',
  };
  function_def = {
    en: 'Define function',
    kana: 'ブロックていぎ',
  };
  function_call = {
    en: 'Call function',
    kana: 'ブロックよびだし',
  };

  function_def_1 = {
    en: 'block',
    kana: 'ブロック',
  };
  function_def_2 = {
    en: ' to ',
    kana: 'を',
  };
  function_def_3 = {
    en: 'accept argument',
    kana: 'パラメータ',
  };
  function_def_4 = {
    en: '',
    kana: 'をうけつけるようにていぎ',
  };

  function_def_5 = {
    en: 'Call block',
    kana: 'ブロック',
  };
  function_def_6 = {
    en: 'passing',
    kana: 'に',
  };
  function_def_7 = {
    en: 'argument',
    kana: 'パラメータ',
  };
  function_def_8 = {
    en: '',
    kana: 'をひきわたしてよびだし',
  };

  if_label = {
    en: 'If',
    kana: 'もし',
  };
  then_label = {
    en: 'Then',
    kana: 'なら',
  };
  else_label = {
    en: 'Else',
    kana: 'でなければ',
  };
  if_else = {
    en: 'If Else',
    kana: 'もしならでなければ',
  };
  list_loop = {
    en: 'ListLoop',
    kana: 'リストをループ',
  };
  list_loop1 = {
    en: 'Retrieve data into variable  ',
    kana: 'へんすう',
  };
  list_loop2 = {
    en: ' and repeat array ',
    kana: 'に、はいれつ',
  };
  list_loop3 = {
    en: '',
    kana: 'からデータをとりだしてくりかえす',
  };
  logic_loop = {
    en: 'Logic Loop',
    kana: '固定の繰り返し',
  };
  range_loop1 = {
    en: 'Count variable',
    kana: 'へんすう',
  };
  range_loop2 = { en: 'repeat form', kana: 'をカウントして' };
  range_loop3 = { en: 'to', kana: 'から' };
  range_loop4 = { en: '', kana: 'までくりかえす' };
  set_array1 = { en: 'Set Array', kana: 'はいれつ' };
  set_array2 = { en: ' to ', kana: 'にカンマくぎったたくさんのデータ' };
  set_array3 = { en: '( canma separeted values)', kana: 'をセット' };

  set_value_default = {
    en: 'number or string',
    kana: 'すうちやもじ',
  };
  set_value1 = { en: 'Set variable', kana: 'へんすう' };
  set_value2 = { en: ' to ', kana: 'にあたい' };
  set_value3 = { en: ' ', kana: 'をセット' };
  save = {
    en: 'Save',
    kana: 'ぼぞん',
  };
  flickr_title = {
    en: 'Choose a background file on Flicker',
    kana: 'Flickerではいけいファイルをえらぶ',
  };
  scene = {
    en: 'Scene',
    kana: 'シーン',
  };
  entity = {
    en: 'Entity',
    kana: '物体',
  };
  multibyte = {
    en: 'Multi-bytes Text',
    kana: 'はんかくえいすうひらがなカタカナ',
  };
  attribute = {
    en: 'Attribute',
    kana: 'ぞくせい',
  };
  ahead = {
    en: 'Always go straight',
    kana: 'つねにちょくしん',
  };
  random_pos = {
    en: 'Random Position',
    kana: 'ランダムないち',
  };
  random_scale = {
    en: 'Random Scale',
    kana: 'ランダムなおおきさ',
  };
  random_color = {
    en: 'Random Color',
    kana: 'ランダムないろ',
  };
  ocean = {
    en: 'Ocean',
    kana: 'すいめん',
  };
  physics = {
    en: 'Physics System',
    kana: 'ぶつりエンジン',
  };
  background = {
    en: 'Environment',
    kana: 'はいけい',
  };
  control = {
    en: 'Control',
    kana: 'せいぎょ',
  };
  value_set = {
    en: 'Set',
    kana: 'へんすうにあたいをセット',
  };
  operator = {
    en: 'Operators',
    kana: 'えんざん',
  };
  operator_gt = {
    en: 'Greater than',
    kana: 'よりおおきい',
  };
  operator_lt = {
    en: 'Less than',
    kana: 'よりちいさい',
  };
  operator_and = {
    en: 'And',
    kana: 'かつ',
  };
  operator_or = {
    en: 'Or',
    kana: 'または',
  };
  operator_not = {
    en: 'Not',
    kana: 'ではない',
  };
  operator_eq = {
    en: 'Equal',
    kana: 'イコール',
  };
  additional = {
    en: 'Additional',
    kana: 'ついか',
  };
  links = {
    en: 'Link',
    kana: 'ほかのせかいへのリンクをつくる',
  };
  dark = {
    en: 'Darkness',
    kana: 'くらやみ',
  };
  spinning = {
    en: 'Spinning',
    kana: 'ずっとかいてん',
  };
  torus_radius = {
    en: 'Torus Radius',
    kana: 'そとがわのはんけい',
  };
  torus_tubular_radius = {
    en: 'Torus Tubular Radius',
    kana: 'チューブのはんけい',
  };
  update_att_1 = {
    en: 'Update block by',
    kana: 'ブロック',
  };
  update_att_2 = {
    en: 'to',
    kana: 'を',
  };
  update_att_3 = {
    en: '',
    kana: 'にへんこう',
  };
  init_process = {
    en: 'Init Process',
    kana: 'しょきかしょり',
  };
  place = {
    en: 'Place  ',
    kana: 'おきかた',
  };
  place_wall = {
    en: 'Place on the wall',
    kana: 'かべにおく',
  };
  place_floor = {
    en: 'Place on the floor',
    kana: 'ゆかにおく',
  };

  ar_button = {
    en: 'Experience AR!',
    kana: 'ARをたいけんしよう！',
  };
  ar_help_text = {
    en: `Experience AR!" Opens the camera screen<br>
    Trace <b>__PLACE__</b> on the camera screen to place the AR<br>
    You can zoom in and out by pinching.`,
    kana: `「ARをたいけんしよう！」でカメラのがめんがひらきます<br>
    カメラがめんで<b>__PLACE__</b>をなぞって、ARをおきましょう<br>
    ２ほんゆびで、おおきくしたり、ちいさくしたりできます。`,
  };

  floor_place = {
    en: `Floor`,
    kana: `ゆか`,
  };
  wall_place = {
    en: `Wall`,
    kana: `かべ`,
  };
  to_block = {
    en: 'To Element',
    kana: 'ブロック',
  };
  to_ar = {
    en: 'To AR',
    kana: 'AR',
  };
  to_att = {
    en: 'To Attribute',
    kana: 'ぞくせいブロック',
  };
  to_vrm_anim = {
    en: 'To VRM Animation',
    kana: 'VRM アニメーションぞくせい',
  };
  to_canvas_glb = {
    en: 'To canvas glb',
    kana: '3Dキャンパスにえがく',
  };
  sky360_image = {
    en: '360° sky image',
    kana: '360ど はいけい がぞう',
  };
  zoom_meeting_number = {
    en: 'Zoom Meeting Number',
    kana: 'ズームミーティングナンバー',
  };
  zoom_meeting_password = {
    en: 'Zoom Meeting Password',
    kana: 'ズームミーティングパスワード',
  };
  title_to_set_zoom_password = {
    en: 'Please enter the meeting password. Blank if not click OK.',
    kana: 'ズームのパスワードをいれてください。パスワードがなければそのままOKをおしてください',
  };
  ar_image_scene = {
    en: 'AR Image Scene',
    kana: 'がぞうARシーン',
  };
  imageTargetSrc = {
    en: 'Image Target Src',
    kana: 'コンパイルしたがぞうマーカー',
  };

  ar_image_marker = {
    en: 'AR Image Marker',
    kana: 'がぞうARマーカー',
  };
  ar_scene_start = {
    en: 'AR Scene Start',
    kana: 'ARシーンスタート',
  };
  ar_face_scene = {
    en: 'AR Face Scene',
    kana: 'かおARシーン',
  };
  ar_face_marker = {
    en: 'AR Face Marker',
    kana: 'かおARマーカー',
  };
  at_lost = {
    en: 'At Lost',
    kana: 'みえなくなったとき',
  };
  disappear = {
    en: 'Disappear',
    kana: 'けす',
  };
  stable = {
    en: 'Stable',
    kana: 'のこす',
  };
}
/**
  box = 
  {
    en :"",
    kana:""
  }
 */
export const block_translation = new BlockTranslation();
